module.exports = __webpack_public_path__ + "img/pretre.228d181f.jpg";